import { render, staticRenderFns } from "./guarantee-video.vue?vue&type=template&id=2bad623e"
import script from "./guarantee-video.vue?vue&type=script&lang=js"
export * from "./guarantee-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports